import React from 'react';
import styled from 'styled-components';

const UIOverlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  pointer-events: none;
`;

export default UIOverlay;
